import api from './api';

export interface WorkplaceTaskFilters {
  role: 'all' | 'performer' | 'assigner' | 'observer';
  period: 'all' | 'today' | 'week' | 'month';
}

export const workplacePreferencesService = {
  async get(): Promise<WorkplaceTaskFilters> {
    const { data } = await api.get<WorkplaceTaskFilters>('/profile/workplace-preferences');
    return data;
  },
  async save(filters: WorkplaceTaskFilters): Promise<WorkplaceTaskFilters> {
    const { data } = await api.put<WorkplaceTaskFilters>('/profile/workplace-preferences', filters);
    return data;
  },
};
